// Formats an invoice id into YYMMDD-XXX style.
// Keeps everything except the last 3 digits as the prefix,
// pads the last 3 digits with leading zeros, and joins with a dash.
// Examples: 251126051 → "251126-051", 2511261 → "2511-261", 51 → "051".
const formatDisplayId = (displayId) => {
  if (!displayId && displayId !== 0) return "";
  const asString = `${displayId}`;
  const suffix = asString.slice(-3).padStart(3, "0");
  const prefix = asString.slice(0, -3);
  return prefix ? `${prefix}-${suffix}` : suffix;
};

const InvoiceHeader = ({orderData}) => {
  const currentDate = new Date(orderData.datetime_created)
  const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`
  const formattedDisplayId = formatDisplayId(orderData.display_id);
  return (
    <>
      <div className="row invoice-header">
        <div className="col-6">
          <div className="mainbrand navbar-brand fontBold">
            <h1 className="ms-0">SJ SAMARINDA</h1>
          </div>
        </div>

        <div className="col-6 mt-4" style={{ paddingLeft: "100px" }}>
          <address className="small-text">
            <span className="label text-start">Tanggal</span> :{" "}
            {formattedDate} <br />
            <span className="label text-start">Nomor nota</span> :{" "}
            {formattedDisplayId} <br />
            <span className="label text-start">Dicetak oleh</span> :{" "}
            {orderData.handler_name} <br />
            <span className="label text-start">Pembeli</span> :{" "}
            {orderData.fullname} <br />
          </address>
        </div>
      </div>
      <hr style={{margin: "8px 0px 8px 0px", height: "3px"}}/>
    </>
  );
};

export default InvoiceHeader;
